var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.948,
    height: 42.99,
    viewBox: "0 0 42.948 42.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate-manuscript",
    transform: "translate(-16.999 -16.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14589",
    "data-name": "Path 14589",
    d: "M45.457,52.646l-2.58,4.3H20.934c-2.977,0-2.934-4.3-2.934-4.3Zm3.047,4.3a3.446,3.446,0,0,0,2.115-.828A2.779,2.779,0,0,1,48.5,56.944ZM51.447,54a2.779,2.779,0,0,1-.828,2.115A3.447,3.447,0,0,0,51.447,54ZM20.934,52.646V19.733A2.187,2.187,0,0,1,23.166,17.5H54.425s2.977,0,2.977,3.721H51.448s0-3.721,2.977-3.721H23.166a2.187,2.187,0,0,0-2.233,2.233C20.934,21.965,20.934,52.646,20.934,52.646Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14590",
    "data-name": "Path 14590",
    d: "M334.837,288.034c-.076-.008-.151-.015-.227-.019-.142-.01-.285-.015-.429-.015a6.181,6.181,0,1,0,0,12.361c.144,0,.288-.005.429-.015.076,0,.151-.011.227-.02l.106-.012a6.181,6.181,0,0,0-.106-12.28Zm1.615,9.272-1.615-.849-.227-.119-.429-.226-2.271,1.194.434-2.529-1.837-1.791,2.538-.368,1.136-2.3.429.87.227.459.48.972,2.538.368-1.837,1.791Z",
    transform: "translate(-283.389 -247.279)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14591",
    "data-name": "Path 14591",
    d: "M304.419,411.6l-1.239,5.573-1.545-1.545L297,417.178l.927-1.545,1.786-2.977,1.671-2.786A6.163,6.163,0,0,0,304.419,411.6ZM314,417.178l-4.636-1.545-1.545,1.545-1.212-5.455a6.148,6.148,0,0,0,3.257-1.438Z",
    transform: "translate(-255.05 -358.688)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14592",
    "data-name": "Path 14592",
    d: "M362.711,319.46l.434,2.529-1.615-.849-.227-.119-.429-.226-2.271,1.194.434-2.529-1.837-1.791,2.538-.368,1.136-2.3.429.87.227.459.48.972,2.538.368Z",
    transform: "translate(-310.082 -271.962)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 0.015,
    transform: "translate(51.221 53.067)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 19.534,
    transform: "translate(51.448 21.221)",
    fill: "none",
    stroke: "#9b2bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCert);
export default __webpack_public_path__ + "static/media/cert.1a966ecbad582218d2776cd2193cb1c9.svg";
export { ForwardRef as ReactComponent };